import { createClient } from '@supabase/supabase-js';
import config from './config';

/** Тот же ключ хранилища, что у всех приложений UNIA — вход общий. */
export const STORAGE_KEY = 'unia-auth-token';

const supabaseUrl = config.SUPABASE_URL;
const mainDomain = config.MAIN_DOMAIN;
const isLocalDev = !supabaseUrl.includes(mainDomain);

// Гибридное хранилище: вся сессия — в localStorage (у cookie лимит 4 КБ), а
// access_token дополнительно зеркалим в маленькую cookie на .unia.one — её
// читают сервисы, которые не знают про Supabase. Внутри телефонной оболочки
// страница живёт на https://localhost, и cookie на чужой домен браузер не
// примет — это не ошибка, зеркало там просто не нужно.
export const hybridStorage = {
  getItem: (key: string): string | null => {
    if (typeof localStorage === 'undefined') return null;
    return localStorage.getItem(key);
  },
  setItem: (key: string, value: string): void => {
    if (typeof localStorage === 'undefined') return;
    localStorage.setItem(key, value);
    if (key === STORAGE_KEY && typeof document !== 'undefined') {
      try {
        const session = JSON.parse(value) as { access_token?: string };
        const token = session?.access_token;
        if (token) {
          const domain = isLocalDev ? 'localhost' : `.${mainDomain}`;
          const secure = isLocalDev ? '' : 'Secure; ';
          document.cookie = `${encodeURIComponent(key)}=${encodeURIComponent(token)}; domain=${domain}; path=/; SameSite=Lax; ${secure}max-age=3600`;
        }
      } catch { /* битая сессия — зеркало не пишем */ }
    }
  },
  removeItem: (key: string): void => {
    if (typeof localStorage !== 'undefined') localStorage.removeItem(key);
    if (typeof document !== 'undefined' && key === STORAGE_KEY) {
      const domain = isLocalDev ? 'localhost' : `.${mainDomain}`;
      document.cookie = `${encodeURIComponent(key)}=; domain=${domain}; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT; SameSite=Lax`;
    }
  },
};

export const supabase = createClient(supabaseUrl, config.SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    storageKey: STORAGE_KEY,
    storage: hybridStorage,
    autoRefreshToken: true,
  },
});
